export default __webpack_public_path__ + "static/media/inaturalist.20871fa6.svg";